import { SHA256 } from "crypto-es/lib/sha256";
import { Hex } from "crypto-es/lib/core";

/**
 * Hashes input in SHA-256 format, like email address or name
 * 
 * @param {string} input The string of data that you want to hash
 */
export function hash(input) {
  return SHA256(input).toString(Hex);
}
